import request from '@/utils/request'

// Cane diagnostic snapshots (BLE 0x1F). Admin read-only.
// Backend: /api/v2/admin/diagnostics/* (request baseURL already includes /api/v2).

export interface DiagnosticSnapshot {
  id: string
  receivedAt: string
  clientCapturedAt: string
  source: 'mobile_app' | 'production_platform' | string
  userId: string | null
  userEmail: string | null
  caneSerialNumber: string
  caneBleMac: string | null
  deviceId: number | null
  firmwareVersion: string | null
  appVersion: string | null
  appPlatform: string | null
  snapshot: any
  metadata: any
  rawPayloadHex?: string | null
  // Present only in grouped (groupByCane) responses: number of snapshots this
  // cane has, and when its first snapshot arrived.
  snapshotCount?: number
  firstReceivedAt?: string
}

export interface SnapshotListParams {
  serial?: string
  userId?: string
  firmwareVersion?: string
  source?: string
  unregistered?: string
  from?: string
  to?: string
  limit?: number
  offset?: number
  // When true, returns one row per cane (its latest snapshot) instead of every
  // snapshot, so the same cane no longer repeats across pages.
  groupByCane?: boolean
}

// One cane's snapshot time-series (primary query-by-serial).
export const getCaneSnapshotsBySerial = (serial: string, params: SnapshotListParams = {}) =>
  request({ url: `/admin/diagnostics/canes/${encodeURIComponent(serial)}/snapshots`, method: 'get', params })

// Filtered list across all canes.
export const listCaneSnapshots = (params: SnapshotListParams = {}) =>
  request({ url: '/admin/diagnostics/cane-snapshots', method: 'get', params })

// Single snapshot detail (incl. raw payload hex).
export const getCaneSnapshotDetail = (id: string) =>
  request({ url: `/admin/diagnostics/cane-snapshots/${id}`, method: 'get' })
